export enum WebsiteWorkflow {
	ACTIVE = 'active',
	PAYING = 'paying',
	BLOCKED = 'blocked',
}
